export default __webpack_public_path__ + "static/media/graignes3.c463603a.jpg";